var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isThisHostAllowed
    ? _c("div", [
        _c("iframe", {
          ref: "iframe",
          attrs: {
            sandbox: _vm.sandboxPermission,
            srcDoc: _vm.communicator,
            src: _vm.communicatorSrc,
            allow: _vm.allowPermission
          },
          on: { load: _vm.setupTracker }
        })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }